/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.125.1-v202604151332-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise } from 'axios';
import { getAxiosInstance, SeeqAxiosRequestConfig } from '@/requests/axios.utilities';
import { isNil, omitBy } from 'lodash';
import * as qs from 'qs';
import * as models from '../model/models';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';

export class sqModelsApiClass {
 
   constructor() {}

  /**
   * @summary Apply a model once by providing inputs to the model's features. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public applyModel(
    body: models.ModelInitialApplicationInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/instances`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Apply a model to a table definition and recompute the newly-added columns. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} tableDefinitionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public applyModelToTable(
    body: models.TableModelApplicationInputV1,
    {
      modelId,
      tableDefinitionId
    } : {
      modelId: string,
      tableDefinitionId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(tableDefinitionId)) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelTableApplicationOutputV1>;
  }

  /**
   * @summary Archive a model by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the model to archive
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public archiveModel(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new draft from a published version. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createDraft(
    {
      modelId,
    } : {
      modelId: string,
    },
    body?: models.ModelDraftCreateInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/drafts`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Create a new model. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createModel(
    body: models.ModelInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Create a new model from reference items. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createModelFromItems(
    body: models.ModelFromIdsInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/from-items`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Create a new model from reference column definitions. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createModelFromTableColumnDefinitions(
    body: models.ModelFromIdsInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/from-table-column-definitions`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Diff two model versions for compatibility. This endpoint is experimental and may change in future releases.
   * @param {string} baseModelId - ID of the base model version
   * @param {string} candidateModelId - ID of the candidate model version
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public diffModels(
    {
      baseModelId,
      candidateModelId
    } : {
      baseModelId: string,
      candidateModelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(baseModelId)) {
      throw new Error("'baseModelId' parameter required");
    }

    if (isNil(candidateModelId)) {
      throw new Error("'candidateModelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(baseModelId))}/diff/${encodeURIComponent(String(candidateModelId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelCompatibilityReportOutputV1>;
  }

  /**
   * @summary Duplicate a model by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public duplicateModel(
    body: models.ModelDuplicateInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/duplicate`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Edit a model by ID. The full model must be provided. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public editModel(
    body: models.ModelInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Edit a specific model version. The model must be unlocked (draft or initial). This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} versionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public editModelVersion(
    body: models.ModelInputV1,
    {
      modelId,
      versionId
    } : {
      modelId: string,
      versionId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(versionId)) {
      throw new Error("'versionId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/versions/${encodeURIComponent(String(versionId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Generates a list of independent and dependent column definitions from a list of items. The independent column definitions do not rely on other columns, while the dependent column definitions do. This can be used to create a model table from calculations. This endpoint is experimental and may change in future releases.
   * @param {string} scopedTo - The ID of the Workbook that the formula creator column rules will be scoped to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public generateColumnModel(
    body: models.ColumnModelInputV1,
    {
      scopedTo
    } : {
      scopedTo: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(scopedTo)) {
      throw new Error("'scopedTo' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/modelData`,
      data: body,

      params: omitBy({
        ['scopedTo']: scopedTo
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ColumnModelOutput>;
  }

  /**
   * @summary Fetch the tables to which a model has been applied. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getAppliedModelTables(
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/tables`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<Array<models.TableDefinitionOutputV1>>;
  }

  /**
   * @summary Get the current user's draft for a model container, if one exists. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getDraft(
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/draft`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Fetch model instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(instanceId)) {
      throw new Error("'instanceId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/instances/${encodeURIComponent(String(instanceId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Fetch model instances for model ID
   * @param {string} modelId
   * @param {number} [offset=0] - The pagination offset, the index of the first model instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of model instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstancesForModel(
    {
      modelId,
      offset,
      limit
    } : {
      modelId: string,
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/instances`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch model instances for table definition ID
   * @param {string} tableDefinitionId
   * @param {number} [offset=0] - The pagination offset, the index of the first model instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of model instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstancesForTable(
    {
      tableDefinitionId,
      offset,
      limit
    } : {
      tableDefinitionId: string,
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableDefinitionId)) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/instances/table/${encodeURIComponent(String(tableDefinitionId))}`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch a model by ID. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModel(
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Fetch the full model for a specific published version. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} versionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModelVersion(
    {
      modelId,
      versionId
    } : {
      modelId: string,
      versionId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(versionId)) {
      throw new Error("'versionId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/versions/${encodeURIComponent(String(versionId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary List all published versions of a model. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {number} [offset=0] - The pagination offset, the index of the first version that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of versions that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModelVersions(
    {
      modelId,
      offset,
      limit
    } : {
      modelId: string,
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/versions`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelVersionListOutputV1>;
  }

  /**
   * @summary Get a list of models. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset, the index of the first item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of models that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModels(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputListV1>;
  }

  /**
   * @summary Get existing model applications to a given table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTableDefinitionModelApplications(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(id))}/model-applications`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelTableApplicationsOutputListV1>;
  }

  /**
   * @summary Publish a draft model as a new version. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public publishModelVersion(
    body: models.ModelPublishInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/versions`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Reapply a model once by providing inputs to the model's features. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reapplyModel(
    body: models.ModelReapplicationInputV1,
    {
      modelId,
      instanceId
    } : {
      modelId: string,
      instanceId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(instanceId)) {
      throw new Error("'instanceId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/instances/${encodeURIComponent(String(instanceId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Reapply a model to a table definition and recompute the results using the updated inputs. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} tableDefinitionId
   * @param {string} applicationId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reapplyModelToTable(
    body: models.TableModelApplicationInputV1,
    {
      modelId,
      tableDefinitionId,
      applicationId
    } : {
      modelId: string,
      tableDefinitionId: string,
      applicationId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(tableDefinitionId)) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    if (isNil(applicationId)) {
      throw new Error("'applicationId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}/${encodeURIComponent(String(applicationId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelTableApplicationOutputV1>;
  }

  /**
   * @summary Retire a model table application by ID
   * @param {string} applicationId
   * @param {boolean} [deleteColumns=false] - If true, deletes the model-controlled columns from the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public retireApplication(
    {
      applicationId,
      deleteColumns
    } : {
      applicationId: string,
      deleteColumns?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(applicationId)) {
      throw new Error("'applicationId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/models/applications/${encodeURIComponent(String(applicationId))}`,

      params: omitBy({
        ['deleteColumns']: deleteColumns
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.TableApplicationRetiredOutputV1>;
  }

  /**
   * @summary Retire a model instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public retireInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(instanceId)) {
      throw new Error("'instanceId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/models/instances/${encodeURIComponent(String(instanceId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceRetiredOutputV1>;
  }

}


export const sqModelsApi = new sqModelsApiClass();
